import InteractiveCatalogPageLayer from '../../model/interactive/InteractiveCatalogPageLayer';
import InteractiveCatalogPageItemParser from './InteractiveCatalogPageItemParser';

export default class InteractiveCatalogPageLayerParser {

    static parse(node) {
        let interactiveCatalogPageLayer = new InteractiveCatalogPageLayer();

        interactiveCatalogPageLayer.name = node.children('ns2\\:name').text();

        node.children('ns2\\:item').each((i, elem) => {
            interactiveCatalogPageLayer.items.push(InteractiveCatalogPageItemParser.parse($(elem)));
        });

        interactiveCatalogPageLayer.hidden = (node.children('ns2\\:hidden').text() == 'true');

        return interactiveCatalogPageLayer;
    }

}
